module.exports = __webpack_public_path__ + "img/anna_chadwick.729e5a18.jpg";